var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMailSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 18.333,
    viewBox: "0 0 20 18.333",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope",
    transform: "translate(0 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_67750",
    "data-name": "Path 67750",
    d: "M19.962,5.542l-7.015,7.015a4.173,4.173,0,0,1-5.893,0L.038,5.542C.027,5.674,0,5.793,0,5.924v10A4.172,4.172,0,0,0,4.167,20.09H15.833A4.172,4.172,0,0,0,20,15.924v-10C20,5.793,19.973,5.674,19.962,5.542Z",
    transform: "translate(0 -0.757)",
    fill: "#e23744"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67751",
    "data-name": "Path 67751",
    d: "M11.892,10.622,19.5,3.009A4.155,4.155,0,0,0,15.957,1H4.291A4.155,4.155,0,0,0,.744,3.009l7.612,7.613a2.506,2.506,0,0,0,3.537,0Z",
    transform: "translate(-0.124)",
    fill: "#e23744"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSmall);
export default __webpack_public_path__ + "static/media/mailSmall.97ea6fe5cf5ab19aab99de0cda0fdfab.svg";
export { ForwardRef as ReactComponent };